import { IconInfo16 as InfoIcon } from "@fabric-ds/icons/react";
import React, { PropsWithChildren, useState } from "react";

// box-shadow: 14px 14px 21px 0px;
type InfoTooltipProps = {
  title: string;
} ;

export const InfoTooltip = ({title, children }: PropsWithChildren<InfoTooltipProps>) => {
  const [active, setActive] = useState(false);

  return (
    <div className="ml-4 inline-block relative cursor-pointer"
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      <InfoIcon className={`inline-block mb-2 cursor-pointer ml-2 ${active ? "text-blue-600" : "text-gray-500"}`} />
      <div style={{left: '-117px', top: '30px'}} className={`absolute font-normal text-12 mt-5 z-10 ${active ? " inline-block" : " hidden"}`}>
        <div className="absolute overflow-hidden" style={{ width: '35px', height: ' 20px', top: '-19px', left: '50%', transform: 'translateX(-50%)'}}>
          <div className="top-0 absolute w-20 h-20 bg-white" style={{transform: 'translateX(-50%) translateY(75%) rotate(45deg)', left: '50%', boxShadow: "14px 14px 21px 0px"}}></div>
          </div>

        <div className="shadow-3 p-16 text-gray-700 text-center bg-white rounded-8" style={{width: "250px"}}>
          <div className="font-bold text-16 leading-18 pb-4">
            {title}
          </div>
          <div className="text-14">{children}</div>
        </div>
      </div>
    </div>
  );
};